import axios from "axios";
import { saveDownloadedBlob } from "@/Utile/ncrmPrivacyDownload.mjs";

// Tenantul nu se trimite niciodată: backendul îl ia din JWT.
export const fetchPrivacyDashboard = async () => (await axios.get("/ncrm/privacy/workspace/dashboard")).data;
// S8.5b: manager Privacy — un job Mailjet eșuat reîncepe ciclul (ID BIGINT ca string).
export const retryMailjetSyncJob = async (jobId) => (await axios.post(`/ncrm/privacy/mailjet-sync/jobs/${jobId}/retry`)).data;

export const fetchPrivacyRegistry = async (params) =>
  (await axios.get("/ncrm/privacy/workspace/registry", { params })).data;

const PURPOSES_PAGE_SIZE = 100; // maximul acceptat de `parsePagination`
const PURPOSES_MAX_PAGES = 50; // plasă de siguranță dacă `has_more` nu se oprește niciodată

// Numai identificarea scopurilor, pentru filtrul registrului; tenantul vine din JWT.
// Endpoint-ul este paginat: urmăm `has_more`, altfel un tenant cu peste 100 de
// scopuri n-ar putea filtra după cele de pe paginile următoare.
export const fetchPrivacyPurposes = async () => {
  const purposes = [];
  for (let page = 0; page < PURPOSES_MAX_PAGES; page += 1) {
    const { data } = await axios.get("/ncrm/privacy/purposes", {
      params: { limit: PURPOSES_PAGE_SIZE, offset: page * PURPOSES_PAGE_SIZE },
    });
    const items = Array.isArray(data?.items) ? data.items : [];
    purposes.push(...items.map(({ id, name }) => ({ id, name })));
    if (!data?.pagination?.has_more || !items.length) break;
  }
  return purposes;
};

// Exportul CSV al registrului (S4.5, manager-only). Se trimit numai filtrele
// vederii curente; serverul le reaplică, verifică limita și auditează exportul.
export const exportRegistryCsv = async (params) => {
  try {
    const response = await axios.post("/ncrm/privacy/configuration/exports/registry", params, { responseType: "blob" });
    const disposition = String(response.headers?.["content-disposition"] || "");
    const filename = disposition.match(/filename="([^"]+)"/)?.[1] || "privacy-registry.csv";
    return { blob: response.data, filename, rowCount: Number(response.headers?.["x-export-row-count"] || 0) };
  } catch (error) {
    // Cu `responseType: blob`, corpul erorii vine tot ca blob: îl citim ca JSON.
    const data = error?.response?.data;
    if (data && typeof data.text === "function") {
      try { error.response.data = JSON.parse(await data.text()); } catch { /* corp ne-JSON */ }
    }
    throw error;
  }
};

// GDPR S11 (GDPR-123): exportul de acces al unei persoane (JSON), numai pentru managerul Privacy; id-ul pleacă în body.
export const exportPersonDsar = async (personId) => {
  try {
    const response = await axios.post("/ncrm/privacy/configuration/exports/dsar", { person_id: personId }, { responseType: "blob" });
    const disposition = String(response.headers?.["content-disposition"] || "");
    const filename = disposition.match(/filename="([^"]+)"/)?.[1] || `dsar-person-${personId}.json`;
    return { blob: response.data, filename };
  } catch (error) {
    const data = error?.response?.data;
    if (data && typeof data.text === "function") {
      try { error.response.data = JSON.parse(await data.text()); } catch { /* corp ne-JSON */ }
    }
    throw error;
  }
};

// Exportul + descărcarea, comune fișei persoanei și registrului (managerul Privacy fără acces la fișă). `isCurrent`
// oprește descărcarea unui răspuns sosit după ce utilizatorul a trecut la alt record; întoarce dacă fișierul s-a salvat.
export const downloadPersonDsar = async (personId, { isCurrent = () => true } = {}) => {
  const { blob, filename } = await exportPersonDsar(personId);
  if (!isCurrent()) return false;
  saveDownloadedBlob(blob, filename);
  return true;
};
